"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetUrlQuery = exports.useUrlQuery = exports.fromCamelToSnake = exports.fromSnakeToCamel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _queryString = require("query-string");

var _reactRouterDom = require("react-router-dom");

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Function to convert from snake to camel case.
 * @param {string} text - Text that needed to be converted.
 * @return {string}
 */
var fromSnakeToCamel = function fromSnakeToCamel(text) {
  return text.replace(/_(\w)/g, function (_, ch) {
    return ch.toUpperCase();
  });
};
/**
 * Function to convert from camel to snake case.
 * @param {string} text - Text that needed to be converted.
 * @return {string}
 */


exports.fromSnakeToCamel = fromSnakeToCamel;

var fromCamelToSnake = function fromCamelToSnake(text) {
  return text.replace(/[A-Z]/g, function (ch) {
    return "_".concat(ch.toLowerCase());
  });
};
/**
 * @param {string[]} params
 * @param {(key: string) => string} [transformKey] - By default transform snake case to camel case.
 * @returns {Record<string, string>}
 */


exports.fromCamelToSnake = fromCamelToSnake;

var useUrlQuery = function useUrlQuery(params) {
  var transformKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fromSnakeToCamel;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var query = (0, _react.useMemo)(function () {
    return (0, _queryString.parse)(search);
  }, [search]);
  var queryKeys = Object.keys(query).map(transformKey);
  var queryValues = Object.values(query);
  var finalQuery = (0, _ramda.zipObj)(queryKeys, queryValues);
  var finalParams = (0, _ramda.pickAll)(params, finalQuery); // eslint-disable-next-line react-hooks/exhaustive-deps

  return (0, _react.useMemo)(function () {
    return finalParams;
  }, Object.values(finalParams));
};
/**
 * @param {(key: string) => string} [transformKey] - By default transform camel case to snake case.
 * @returns {(query: Record<string, string> = {}, replaceParams: boolean = false, replaceHistory: boolean = false): void}
 *
 * @example
 * const setUrlQuery = useSetUrlQuery();
 *
 * // push a new state of url query params without replace
 * // e.g. current https://example.com/?q=asdasd&page=3
 * setUrlQuery({ p: 4 }); // will be https://example.com/?q=asdasd&p=4
 *
 * // but if you will pass "replaceParams" - true, and call it again
 * setUrlQuery({ q: 'asdads' }, true); // will be https://example.com/?q=asdads
 *
 * // also you may pass "replaceHistory" a true value, to prevent changing browser history on search
 * setUrlQuery({ q: 'asdads' }, true, true);
 */


exports.useUrlQuery = useUrlQuery;

var useSetUrlQuery = function useSetUrlQuery() {
  var transformKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromCamelToSnake;

  var _useHistory = (0, _reactRouterDom.useHistory)(),
      push = _useHistory.push,
      replace = _useHistory.replace;

  var _useLocation2 = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation2.pathname,
      search = _useLocation2.search;

  var currentQuery = (0, _react.useMemo)(function () {
    return (0, _queryString.parse)(search);
  }, [search]);
  return (0, _react.useCallback)(function () {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var replaceParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var replaceHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var queryKeys = Object.keys(query).map(transformKey);
    var finalQuery = (0, _ramda.zipObj)(queryKeys, Object.values(query));
    var finalParams = replaceParams ? finalQuery : _objectSpread(_objectSpread({}, currentQuery), finalQuery);
    var queryString = (0, _queryString.stringify)((0, _utils.pickNotEmptyAndNil)(finalParams));
    var historyAction = replaceHistory ? replace : push;
    historyAction({
      pathname: pathname,
      search: queryString
    });
  }, [currentQuery, push, replace, pathname, transformKey]);
};

exports.useSetUrlQuery = useSetUrlQuery;